import { reaction } from 'mobx';

import { isBrowser } from '@vtblife/layout-components/utils';

import { withTrailingSlash } from '../utils/with-trailing-slash';
import { RootStore } from './root';

export interface PageStoreOptions {
    page: any;
    readOnly: boolean;
    blocksSchema: any;
    blocksUiSchema: any;
    overridenEditorSrc: string | null;
    hasUserSubscription?: boolean;
}

/**
 * Отдельный стор для реакций. Запускает реакции после инициализации всех остальных сторов
 * Нужен для цикилически зависимых друг от друга сторов, внутри которых не могут корректно отработать реакции. Например, userStore и configStore зависят друг от друга.
 */
export class ReactionsStore {
    rootStore: RootStore;

    disposables: (() => void)[] = [];

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        if (isBrowser()) {
            this.setupReactions();
        }
    }

    setupReactions() {
        this.disposables.push(
            reaction(
                () => this.rootStore.configStore?.landingsWithAuthVariables,
                async () => {
                    if (
                        this.rootStore.configStore.landingsWithAuthVariables?.includes(
                            withTrailingSlash(this.rootStore.historyStore.location.pathname),
                        )
                    ) {
                        this.rootStore.userStore.fetchAuthData();
                    }
                },
                { fireImmediately: true },
            ),
        );
    }

    dispose() {
        this.disposables.forEach((fn) => fn());
        this.disposables = [];
    }
}
